import loginReducer from '@store/slices/login.slice';
import bookingReducer from '@store/slices/booking.slice';
import cardReducer from '@store/slices/card.slice';
import commonReducer from '@store/slices/common.slice';
import partnerSessionReducer from '@store/slices/partnerSession.slice';
export default {
  login: loginReducer,
  card: cardReducer,
  booking: bookingReducer,
  common: commonReducer,
  partnerSession: partnerSessionReducer,
};
